import React from 'react';
import ContactLayout from './contact-layout';

export default class Contact extends React.Component<{}, {}> {
    render(){
        return(
            <ContactLayout/>
        )
    }
}